'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mk_MK = require('../vc-pagination/locale/mk_MK');

var _mk_MK2 = _interopRequireDefault(_mk_MK);

var _mk_MK3 = require('../date-picker/locale/mk_MK');

var _mk_MK4 = _interopRequireDefault(_mk_MK3);

var _mk_MK5 = require('../time-picker/locale/mk_MK');

var _mk_MK6 = _interopRequireDefault(_mk_MK5);

var _mk_MK7 = require('../calendar/locale/mk_MK');

var _mk_MK8 = _interopRequireDefault(_mk_MK7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  locale: 'mk',
  Pagination: _mk_MK2['default'],
  DatePicker: _mk_MK4['default'],
  TimePicker: _mk_MK6['default'],
  Calendar: _mk_MK8['default'],
  global: {
    placeholder: 'Ве молиме означете'
  },
  Table: {
    filterTitle: 'Мени за филтрирање',
    filterConfirm: 'ОК',
    filterReset: 'Избриши',
    selectAll: 'Одбери страница',
    selectInvert: 'Инвертирај страница'
  },
  Modal: {
    okText: 'ОК',
    cancelText: 'Откажи',
    justOkText: 'ОК'
  },
  Popconfirm: {
    okText: 'ОК',
    cancelText: 'Откажи'
  },
  Transfer: {
    searchPlaceholder: 'Пребарај тука',
    itemUnit: 'предмет',
    itemsUnit: 'предмети'
  },
  Upload: {
    uploading: 'Се прикачува...',
    removeFile: 'Избриши фајл',
    uploadError: 'Грешка при прикачување',
    previewFile: 'Прикажи фајл',
    downloadFile: 'Преземи фајл'
  },
  Empty: {
    description: 'Нема податоци'
  },
  Icon: {
    icon: 'Икона'
  },
  Text: {
    edit: 'Уреди',
    copy: 'Копирај',
    copied: 'Копирано',
    expand: 'Зголеми'
  },
  PageHeader: {
    back: 'Назад'
  }
};